import './style.css';
import './home.css';
import { catalogBadgeLabel, catalogSections, publicCatalogItems, type CatalogItem } from './catalog';
import { siteBrandMarkup } from './site-chrome';

function badgeMarkup(item: CatalogItem): string {
  if (item.badges.length === 0) return '';
  return `
    <span class="catalog-badges" aria-label="${item.badges.map(catalogBadgeLabel).join(', ')}">
      ${item.badges.map((badge) => `<span class="catalog-badge ${badge}">${catalogBadgeLabel(badge)}</span>`).join('')}
    </span>`;
}

function cardMarkup(item: CatalogItem, index: number): string {
  return `
    <li style="--catalog-order:${index}">
      <a class="catalog-card" href="${item.href}">
        <span class="catalog-icon ${item.tone} ${item.icon}" aria-hidden="true"></span>
        <span class="catalog-copy">
          <strong>${item.title}</strong>
          <small>${item.description}</small>
        </span>
        ${badgeMarkup(item)}
      </a>
    </li>`;
}

export function mountHome(): void {
  const app = document.querySelector<HTMLDivElement>('#app');
  if (!app) throw new Error('메인 화면을 찾지 못했습니다.');

  const items = publicCatalogItems();
  let cardOrder = 0;
  const sectionOrder = new Map([
    ['tools-play', 0],
    ['games', 1],
  ] as const);
  const sections = catalogSections(items).sort((left, right) => (
    (sectionOrder.get(left.id) ?? Number.POSITIVE_INFINITY)
    - (sectionOrder.get(right.id) ?? Number.POSITIVE_INFINITY)
  ));
  const sectionMarkup = sections.map((section, sectionIndex) => {
    const cards = section.items.map((item) => cardMarkup(item, cardOrder++)).join('');
    const titleId = `catalog-${section.id}-title`;
    return `
      <section class="catalog-section catalog-${section.id}" aria-labelledby="${titleId}" style="--section-order:${sectionIndex}">
        <div class="catalog-heading">
          <span class="catalog-heading-copy"><h2 id="${titleId}">${section.title}</h2><small>${section.description}</small></span>
          <span class="catalog-count" aria-label="${section.title} ${section.items.length}개">${section.items.length}</span>
        </div>
        <ul>${cards}</ul>
      </section>`;
  }).join('');
  document.documentElement.classList.add('home-page');
  document.title = '오늘툴 | 심심할 때 쓰는 작은 도구들';
  app.innerHTML = `
    <div class="home-shell">
      <div class="home-glow home-glow-one" aria-hidden="true"></div>
      <div class="home-glow home-glow-two" aria-hidden="true"></div>
      <div class="home-glow home-glow-three" aria-hidden="true"></div>
      <div class="home-glow home-glow-four" aria-hidden="true"></div>
      <div class="home-glow home-glow-five" aria-hidden="true"></div>
      <div class="home-glow home-glow-six" aria-hidden="true"></div>
      <header class="site-brand-header home-header">${siteBrandMarkup({ current: true, className: 'home-wordmark' })}</header>
      <main class="home-main">
        <section class="home-intro" aria-labelledby="home-title">
          <h1 id="home-title">심심할 때 쓰는 작은 도구들</h1>
          <p>필요한 순간 꺼내 쓰는 도구와 놀이부터 친구들과 즐기는 게임까지 모았어요.</p>
        </section>
        <div class="catalog" aria-label="오늘툴 모음">${sectionMarkup}</div>
      </main>
      <footer class="home-footer">
        <a href="/privacy/">개인정보처리방침</a>
        <a href="/terms/">이용약관</a>
        <span>© 2026 오늘툴</span>
      </footer>
    </div>`;
}

const rootPaths = new Set(['/', '/index.html']);
if (rootPaths.has(location.pathname)) {
  mountHome();
} else {
  void import('./main');
}
